/* eslint-disable react-hooks/exhaustive-deps */
import styles from "./VoiceCallLink.module.css"
import {useContext} from "react"
import {VoiceCallContext} from "context/VoiceCallContext"
import cx from "classnames"
import {DialerStudent} from "types/auto-dialer"

type Props = {
    callTo?: DialerStudent
    departmentId?: number
    children: React.ReactNode
    className?: string
}

export function VoiceCallLink({callTo, departmentId, children, className}: Props) {
    const {calling, startCall, onEndedCallback} = useContext(VoiceCallContext)

    const handleStartCall = () => {
        if (calling || !callTo) return
        startCall(callTo, departmentId)
        onEndedCallback(null)
    }

    return (
        <div className={cx(styles.callLinkWrap, className)} onClick={handleStartCall}>
            {children}
        </div>
    )
}
